import { getDistinctItems } from '../../../../utils/array-utils';
import { reduceToArray } from '../../../../utils/reduce-to-array';
import { filterFilms } from '../../../filter/utils/filter-films';
import { getAllFilms } from './get-all-films';
import { getFilmsForSite } from './get-films-for-site';
export const getFilms = (siteIds, filter) => {
    const filmsForSites = siteIds ? getDistinctItems(reduceToArray(siteIds, getFilmsForSite).flat()) : undefined;
    const films = siteIds ? filmsForSites : getAllFilms();
    return filter && films ? filterFilms(filter, films) : films;
};
//# sourceMappingURL=get-films.js.map